'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = performReauth;

var _isUnauthorizedResponse = require('../isUnauthorizedResponse');

var _isUnauthorizedResponse2 = _interopRequireDefault(_isUnauthorizedResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function performReauth(reauth, apiContext) {
  return reauth().then(function (reauthResponse) {
    apiContext.setTokens(reauthResponse.data);

    return {
      auth: {
        isNotAuthenticated: false,
        newTokenData: reauthResponse.data
      }
    };
  }).catch(function (reauthError) {
    if ((0, _isUnauthorizedResponse2.default)(reauthError)) {
      apiContext.clearTokens();

      return {
        auth: {
          isNotAuthenticated: true
        }
      };
    }

    return {
      auth: {
        isNotAuthenticated: false
      }
    };
  });
}
//# sourceMappingURL=performReauth.js.map